import { Component, OnInit } from '@angular/core';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-prod-grp-langs',
  templateUrl: './prod-grp-langs.component.html',
  styleUrls: ['./prod-grp-langs.component.css']
})
export class ProdGrpLangsComponent implements OnInit {
    prodGrpId;

    public inputListLanguages: LanguageItem[] = [];

    public saving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.prodGrpId = this.stateService.getStateParams()['prodgrp_id'];
    }

    private async loadLanguages() {
        if (!!this.prodGrpId) {
            this.inputListLanguages = await this.datatask.Post(3182, { prodgrp_id: this.prodGrpId });
        }
    }

    public async saveChanges() {
        if (!!this.inputListLanguages) {
            try {
                this.saving = true;

                await this.datatask.Post(3183, this.inputListLanguages);

                this.stateService.back();
            } finally {
                this.saving = false;
            }
        }
    }

    private async init() {
        this.loadLanguages();
    }

    ngOnInit() {
        this.init();
    }
}

interface LanguageItem {
    prodgrp_id: number;
    prodgrplang_name: string;
    language_id: string;
    language_name: string;
    orderby: number;
}

//(function () {
//    'use strict';

//    const module = angular.module('imApp');

//    module.component('prodGrpLangs', {
//        templateUrl: 'views/components/views/prodGrpLangs/prodGrpLangs.template.html?v=' + module.version,
//        controllerAs: 'vm',
//        controller: ['$stateParams', 'stateService', 'prodGrpLangsService', function ($stateParams, stateService, prodGrpLangsService) {

//            // #region VARIABLES & DEFINITIONS

//            const vm = this;
//            let prodGrpId = $stateParams.prodgrp_id;

//            vm.model = {
//                inputListLanguages: [],
//                lockedSave: false
//            };

//            // #endregion VARIABLES & DEFINITIONS

//            // #region LOAD PROCEDURE FUNCTION CALL

//            async function loadLanguages() {
//                vm.model.inputListLanguages = await prodGrpLangsService.listLanguages({ prodgrp_id: prodGrpId });
//            }

//            // #endregion LOAD PROCEDURE FUNCTION CALL

//            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//            vm.saveChanges = function () {
//                vm.model.lockedSave = true;

//                prodGrpLangsService.saveObj({ records: vm.model.inputListLanguages }).then(function () {
//                    vm.model.lockedSave = false;
//                    stateService.back();
//                }, function () {
//                    vm.model.lockedSave = false;
//                });
//            }

//            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//            // #region ON INIT FUNCTION

//            vm.$onInit = function () {
//                loadLanguages();
//            }

//            // #endregion ON INIT FUNCTION

//        }]
//    });
//})();
